/**
 * Escalera de niveles del Club, por país (umbral de puntos desde el que se
 * entra a cada nivel).
 *
 * Son reglas de negocio provistas por Puppis, no datos de ejemplo: ninguna API
 * las expone, por eso viven acá (igual que shared/beneficios.ts).
 *
 *   Argentina: General 0-2.599 · Aliado 2.600-3.999 · Amigo Fiel 4.000-6.499 · Fanático 6.500+
 *   Colombia:  General 0-2.499 · Aliado 2.500-7.499 · Amigo Fiel 7.500-16.999 · Fanático 17.000+
 */

export interface UmbralNivel {
  nombre : string;
  desde : number;
}

const AR : UmbralNivel[] = [
  { nombre: 'General',    desde: 0 },
  { nombre: 'Aliado',     desde: 2600 },
  { nombre: 'Amigo Fiel', desde: 4000 },
  { nombre: 'Fanático',   desde: 6500 }
];

const CO : UmbralNivel[] = [
  { nombre: 'General',    desde: 0 },
  { nombre: 'Aliado',     desde: 2500 },
  { nombre: 'Amigo Fiel', desde: 7500 },
  { nombre: 'Fanático',   desde: 17000 }
];

const POR_PAIS : { [pais : string] : UmbralNivel[] } = { AR, CO };

export function umbralesDePais(countryCode : string | null | undefined) : UmbralNivel[] {
  return POR_PAIS[(countryCode ?? 'AR').toUpperCase()] ?? AR;
}

/**
 * Clave para comparar nombres de nivel: sin mayúsculas ni tildes, y con los
 * sinónimos unificados ("Mejor Amigo" es como se llama Amigo Fiel en algunos
 * lugares). Así no depende de cómo venga escrito el nivel desde la API.
 */
export function claveNivel(nombre : string | null | undefined) : string {
  const k = (nombre ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
  return k === 'mejor amigo' ? 'amigo fiel' : k;
}

export function mismoNivel(a : string | null | undefined, b : string | null | undefined) : boolean {
  return !!a && !!b && claveNivel(a) === claveNivel(b);
}
